import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import Title from '../../../components/Editor/Title';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: { label: { label, isError } },
	} = state;

	return {
		label,
		isError,
	};
};

export default connect(mapStateToProps)(Title);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Title/index.tsx